import { Spin } from 'antd';
import React, { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CustomBook } from '../../../components/Book/Book';
import FloatButton from '../../../components/FloatButton/FloatButton';
import HeaderPage from '../../../components/HeaderPage/HeaderPage';
import CustomSearch from '../../../components/Search/CustomSearch';
import { environment } from '../../../environment';
import useSearchParam from '../../../hooks/useQueryParams';
import { getAllBookFromGoogle } from '../../../service/book';

import { main_color_50 } from '../../../styles/_variables';

import styles from './BookSearch.module.scss';
import useHeader from '../../../hooks/useHeader';

const BookSearch: React.FC = () => {
  const navigate = useNavigate();

  const [filter, setFilter] = useSearchParam<string, any>('filter')
  const [search, setSearchState] = useSearchParam<string, string>('search')
  const [page, setPage] = useSearchParam<string, number>('page')

  if(!search) setSearchState('a')
  if(!filter) setFilter('intitle')
  if(!page) setPage('0')

  const {
      data: books, 
      isFetching } = useQuery(
    ['book', filter, page, search],
    () => getAllBookFromGoogle(search, filter, page),
    {refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled: !!(search || page || filter)},
  );

  useHeader({ header: 'Livros' });

  return (
    <div className={styles.container}>
      <HeaderPage header="Buscar livros" bageColor={main_color_50}/>
      <CustomSearch 
        style={styles.search}
        queryParams="search"
        />
      {/* <Filter>
        <FilterItem 
          onClick={e => setFilter('inauthor')} 
          active={filter === 'inauthor'}>Autor</FilterItem>
        <FilterItem 
          active={filter === 'intitle'}
          onClick={e => setFilter('intitle')}
          > Título
          </FilterItem>
      </Filter> */}
      <h2>
      </h2>
      <div className={styles.containerBooks}>
        {
          books?.map(book => 
            <section 
              className={styles.containerBook}
              onClick={e => {
                const path = book?.id ? `/book/local/${book.id}` :`/book/google/${book.idGoogle}`
                navigate(path)
              }}>
              <CustomBook
                book={book}
                bookId={book?.id}
                partialBook={{
                  author:book.author,
                  name: book.name,
                  page: book.page,
                  imageLink: book.imageLink || environment.noCoverBook
                }}
                key={book.idGoogle || book?.id}
              />
            </section>
          )
        }
        {isFetching && 
          <Spin spinning={isFetching}/>}
        {!books?.length && !isFetching && <>Nada a mostrar</>}
        <FloatButton
          style={styles.button}
          onClick={e => navigate('/book/add')}
          />
      </div>
    </div>
  )
}

export default BookSearch;